module.exports = __webpack_public_path__ + "img/1.31f27fb9.jpg";